import { partnerService } from "@/_services";

export const partner = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
    entity: {
      data: {},
      status: {},
    },
    oficinas: {
      data: [],
      status: {},
    },
    solucion: {
      data: {},
      status: {},
    },
    allPartners: {
      data: {},
      status: {},
    },
    update: {
      data: [],
      status: {},
    },
  },
  mutations: {
    getPartnersRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getPartnersSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getPartnersError(state, error) {
      state.list.data = null;
      state.list.status = {
        error,
      };
    },
    getOficinasRequest(state) {
      state.oficinas.status = {
        loading: true,
      };
    },
    getOficinasError(state, error) {
      state.oficinas.data = null;
      state.oficinas.status = {
        error,
      };
    },
    getOficinasSuccess(state, list) {
      state.oficinas.data = list;
      state.oficinas.status = {
        loaded: true,
      };
    },

    getAllPartnersRequest(state) {
      state.allPartners.status = {
        loading: true,
      };
    },
    getAllPartnersError(state, error) {
      state.allPartners.data = null;
      state.allPartners.status = {
        error,
      };
    },
    getAllPartnersSuccess(state, list) {
      state.allPartners.data = list;
      state.allPartners.status = {
        loaded: true,
      };
    },

    partnerSolucionRequest(state) {
      state.solucion.status = {
        solving: true,
      };
    },
    partnerSolucionError(state, error) {
      state.solucion.data = null;
      state.solucion.status = {
        error,
      };
    },
    partnerSolucionSuccess(state, res) {
      state.solucion.data = res;
      state.solucion.status = {
        solved: true,
      };
    },
    getPartnerByCodeRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getPartnerByCodeError(state, error) {
      state.entity.data = null;
      state.entity.status = {
        error,
      };
    },
    getPartnerByCodeSuccess(state, res) {
      state.entity.data = res;
      state.entity.status = {
        loaded: true,
      };
    },

    updatePartnerRequest(state) {
      state.update.status = {
        updating: true,
      };
    },
    updatePartnerError(state, error) {
      state.update.data = null;
      state.update.status = {
        error,
      };
    },
    updatePartnerSuccess(state, response) {
      state.update.data = response;
      state.update.status = {
        updated: true,
      };
    },
  },
  actions: {
    getPartners({ commit }, request) {
      commit("getPartnersRequest");
      partnerService
        .getPartners(request.pagination, request.query)
        .then((response) => {
          commit("getPartnersSuccess", response);
        })
        .catch((error) => {
          commit("getPartnersError", error);
        });
    },
    getOficinas({ commit }, filters) {
      commit("getOficinasRequest");
      partnerService
        .getOficinas(filters)
        .then((list) => {
          commit("getOficinasSuccess", list);
        })
        .catch((error) => {
          commit("getOficinasError", error);
        });
    },
    getAllPartners({ commit }) {
      commit("getAllPartnersRequest");
      partnerService
        .getAllPartners()
        .then((list) => {
          commit("getAllPartnersSuccess", list);
        })
        .catch((error) => {
          commit("getAllPartnersError", error);
        });
    },
    partnerSolucion({ commit }, req) {
      commit("partnerSolucionRequest");
      partnerService
        .partnerSolucion(req.id, req.body)
        .then((res) => {
          commit("partnerSolucionSuccess", res);
        })
        .catch((error) => {
          commit("partnerSolucionError", error);
        });
    },
    getPartnerByCode({ commit }, code) {
      commit("getPartnerByCodeRequest");
      partnerService
        .getPartnerByCode(code)
        .then((res) => {
          commit("getPartnerByCodeSuccess", res);
        })
        .catch((error) => {
          commit("getPartnerByCodeError", error);
        });
    },
    updatePartner({ commit }, request) {
      commit("updatePartnerRequest");
      partnerService
        .updatePartner(request.id, request.body)
        .then((res) => {
          commit("updatePartnerSuccess", res);
        })
        .catch((error) => {
          commit("updatePartnerError", error);
        });
    },
  },
};
